import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoadingService } from "../../../common/layout/loading.service";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { GenericErrorHandlerService } from '../../../core/services/generic-error-handler.service';

@Component({
  selector: 'ns-remind-password',
  templateUrl: './remind-password.component.html',
  styleUrls: ['./remind-password.component.scss']
})
export class RemindPasswordComponent implements OnInit {

    public form: FormGroup = this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]],
    });
  constructor(
      private formBuilder: FormBuilder,
      public loadingService: LoadingService,
      private authService: AuthService,
      private router: Router,
      private genericErrorHandlerService: GenericErrorHandlerService
  ) { }

  ngOnInit() {
  }

    onSubmit() {
        this.genericErrorHandlerService.showErrors(this.form);

        if (this.form.valid) {
            this.authService.remindPassword(this.form.getRawValue(),
                () => this.router.navigate(['logowanie']));
        }
    }
}
